import styled from "styled-components";

import { colourScheme } from "utils/styling/colours";

export const NestedCommentsContainer = styled.div`
    margin-left: 1rem;
    padding-left: 1rem;
    border-left: 2px solid ${colourScheme.white};
    margin-top: 1rem;
`;
